import React, {Component} from 'react'

interface IProps{
    error?: string,
    value: string | number,
    isDisabled: boolean,
    info?: string,
    parsed?: string | number,
}
export default function Cell ({error, value, isDisabled, info}: IProps):JSX.Element {
    const finalClassName = isDisabled ? 'disabledCell' : null
    if(error){
        return (
            <td className="errorCell">
                <span title={error}>{value}</span>
            </td>
        )
    }
    if(!value){
        return (
            <td className="null">
                <span>null</span>
            </td>
        )
    }
    return (
        <td className={finalClassName}>
            <span title={info ? info : ""}>{value}</span>
        </td>
    )
}